export default __webpack_public_path__ + "static/media/filter.8465a0b4.svg";